import { render } from "./PortfolioModalThree.vue?vue&type=template&id=231f7174"
import script from "./PortfolioModalThree.vue?vue&type=script&lang=js"
export * from "./PortfolioModalThree.vue?vue&type=script&lang=js"
script.render = render

export default script